import {
  ExtrasConfiguration,
  ExtraType,
  GlassesType,
  LensPackType,
  OpticalData,
} from '@grandvisionhq/products'

// Trafikglas = polarized-pack
// Blaljusfilter = screen-protection-pack
// Komfortglas = personalized-pack
// Sjalvtonande glas = light-adaptive-pack
// Gradalfard glas = gradient-pack
// Helfargade glas = tinted-lenses-pack

const extraTypes: ExtraType[] = [
  'polarized-pack', // 0
  'screen-protection-pack', // 1
  'personalized-pack', // 2
  'light-adaptive-pack', // 3
  'gradient-pack', // 4
  'tinted-lenses-pack', // 5
]

const extrasConfiguration: ExtrasConfiguration = {
  frameAndMonofocal: {
    basic: [],
    bronze: [1, 3, 4, 5],
    silver: [1, 3, 4, 5],
    gold: [1, 3, 4, 5],
    platinum: [0, 1, 2, 3, 4, 5],
    diamond: [0, 2, 3, 4, 5],
  },
  frameAndMultifocal: {
    basic: [],
    bronze: [1, 3, 4, 5],
    silver: [1, 3, 4, 5],
    gold: [1, 3, 4, 5],
    platinum: [0, 1, 3, 4, 5],
    diamond: [0, 3, 4, 5],
  },
}

export function getAllowedExtras(
  selectedGlasses: GlassesType,
  selectedLensPack: LensPackType,
  selectedExtras: ExtraType[],
  opticalData?: OpticalData
): ExtraType[] {
  // Frames and kids glasses have no extras.
  if (selectedGlasses === 'frameOnly' || (opticalData && opticalData.isKidsGlasses)) {
    return []
  }
  const allowedExtras =
    extrasConfiguration[selectedGlasses] &&
    extrasConfiguration[selectedGlasses][selectedLensPack]
      .map((index) => extraTypes[index])
      .filter((value) => {
        return !(
          // When the polarized-pack is selected, all other filters are disabled.
          (
            (selectedExtras.includes('polarized-pack') && value !== 'polarized-pack') ||
            // When screen-protection-pack is selected, disabled light-adaptive-pack,
            (selectedExtras.includes('screen-protection-pack') &&
              value === 'light-adaptive-pack') ||
            // and the other way around.
            (selectedExtras.includes('light-adaptive-pack') && value === 'screen-protection-pack')
          )
        )
      })
  return allowedExtras
}
